import AnchorHeading from './anchor-heading';

export default AnchorHeading;
